export const USERS_CONFIG = {
  guest: {
    customerData: {
      name: 'Guest',
      offerTableName: 'Guest'
    },
    profileData: {
      name: 'Guest',
      picture: 'assets/images/admin.jpg'
    },
    propertiesKey: 'GUEST',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    isStorebrand: false,
    showAgentOrganisationId: true,
    isKNIF: true,
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    actions: {
      assigneeOffer: false,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: false,
      offerProductActions: false,
      editOfferStatus: false,
      sendOfferComments: false,
      viewOfferStatusLogic: false,
      viewProductProperties: false,
      showOfferLink: false,
      sendOfferInit: false,
      isTarifDate: false
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: ''
    },
    userUiUrl: {
      prod: '',
      dev: ''
    }
  },
  INTELLITECH: {
    customerData: {
      name: 'INTELLITECH',
      offerTableName: 'Intellitech'
    },
    propertiesKey: 'INTELLITECH',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: false,
    showAgentOrganisationId: true,
    isKNIF: true,
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    actions: {
      assigneeOffer: true,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      offerProductActions: true,
      sendCompleteOfferReminder: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'tiaCustomerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      logo: 'assets/images/customer_logo/logo-KLP.png',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://demo.intellitech.no/',
      dev: 'https://demo-dev.intellitech.no/'
    }
  },
  KLP: {
    customerData: {
      name: 'KLP',
      offerTableName: 'Klp',
      logo: 'logo-KLP.png'
    },
    isDefaultProperties: true,
    isKlpFlow: true,
    propertiesKey: 'KLP',
    customerNumberKey: 'CUSTOMER_NUMBER_KLP',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL_KLP',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-KLP.pdf',
    isStorebrand: true,
    hasClaimsIn3YearsDrpdown: true,
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      isTiaIntegration: true,
      assigneeOffer: true,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      sendCompleteOfferReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'tiaCustomerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false,
      isCustomerNumberMenuForm: true
    },
    profileData: {
      name: 'Admin',
      logo: 'assets/images/customer_logo/logo-KLP.png',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://tilbud.klp.no/',
      dev: 'https://klp-front-end-dev.herokuapp.com/'
    }
  },
  BALDER: {
    customerData: {
      name: 'BALDER',
      offerTableName: 'Balder',
    },
    isDefaultProperties: true,
    isKlpFlow: true,
    isKNIF: true,
    propertiesKey: 'KLP',
    customerNumberKey: 'CUSTOMER_NUMBER_KLP',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL_KLP',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-KLP.pdf',
    isStorebrand: true,
    hasClaimsIn3YearsKolibriDrpdown: true,
    yearsInPreviousCompanyKolibriDrpdown: true,
    isRegularPEPProperty: true,
    showAgentOrganisationId: true,
    actions: {
      isTiaIntegration: false,
      assigneeOffer: true,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      sendCompleteOfferReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false,
      isCustomerNumberMenuForm: true
    },
    profileData: {
      name: 'Admin',
      logo: 'assets/images/customer_logo/logo-KLP.png',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://tilbud.balderforsikring.no/',
      dev: 'https://balder-front-end-27ce55cb5caf.herokuapp.com/'
    }
  },
  HUSEIERNE: {
    customerData: {
      name: 'HUSEIERNE',
      offerTableName: 'Huseierne',
    },
    isDefaultProperties: true,
    isKlpFlow: true,
    isKNIF: true,
    propertiesKey: 'KLP',
    customerNumberKey: 'CUSTOMER_NUMBER_KLP',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL_KLP',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-KLP.pdf',
    isStorebrand: true,
    hasClaimsIn3YearsDrpdown: true,
    showAgentOrganisationId: true,
    actions: {
      isTiaIntegration: false,
      assigneeOffer: true,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      sendCompleteOfferReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'tiaCustomerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false,
      isCustomerNumberMenuForm: false
    },
    profileData: {
      name: 'Admin',
      logo: 'assets/images/customer_logo/logo-KLP.png',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://huseierne-front-end-8b1f9567d0c1.herokuapp.com/',
      dev: 'https://huseierne-front-end-8b1f9567d0c1.herokuapp.com/'
    }
  },
  KOLIBRI: {
    customerData: {
      name: 'KOLIBRI',
      offerTableName: 'Kolibri'
    },
    isKolibriFlow: true,
    hasKolibriHierarchy: true,
    isDefaultProperties: true,
    isCreditCheckDisabled: true,
    isOfferDiscount: true,
    propertiesKey: 'KOLIBRI',
    customerNumberKey: 'CUSTOMER_NUMBER_KLP',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL_KLP',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: '',
    isStorebrand: true,
    isKNIF: true,
    hasClaimsIn3YearsKolibriDrpdown: true,
    yearsInPreviousCompanyKolibriDrpdown: true,
    hasKolibriClientCategory: true,
    genericPreviousCompanyDropdown: true,
    isPreviousCompanyFeature: true,
    isRegularPEPProperty: true,
    focusAccept: true,
    showAgentOrganisationId: false,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false,
      isMultiplePaymentPeriods: false,
      downloadPdfButton: true
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
      logo: 'assets/images/customer_logo/KolibriLogoSortSVG.svg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://tilbud.kolibriforsikring.no/',
      dev: 'https://kolibri-front-end-dev-635df36d4d17.herokuapp.com/'
    }
  },
  NC_KLP: {
    customerData: {
      name: 'NC KLP',
      offerTableName: 'NC Klp',
      logo: 'logo-KLP.png'
    },
    isKlpFlow: true,
    isDefaultProperties: true,
    propertiesKey: 'KLP',
    customerNumberKey: 'CUSTOMER_NUMBER_KLP',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL_KLP',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-KLP.pdf',
    isStorebrand: true,
    hasClaimsIn3YearsDrpdown: true,
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      isTiaIntegration: true,
      assigneeOffer: true,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: false,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      sendCompleteOfferReminder: true,
      customerNumberObject: 'tiaCustomerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false,
      isCustomerNumberMenuForm: true
    },
    profileData: {
      name: 'Admin',
      logo: 'assets/images/customer_logo/logo-KLP.png',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://nc.tilbud.klp.no/',
      dev: 'https://klp-front-end-dev.herokuapp.com/'
    }
  },
  BILDELER: {
    customerData: {
      name: 'BILDELER',
      offerTableName: 'CODAN'
    },
    propertiesKey: 'BILDELER',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: true,
    shareDataFeatureKey: 'SHARE_DATA_NORD',
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: false,
      sendProcessOfferEmail: false,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'tiaCustomerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      logo: 'assets/images/customer_logo/logo-KLP.png',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://tilbud.bildeler.no/',
      dev: 'https://bildeler-front-end-dev.herokuapp.com/'
    }
  },
  PRONANS: {
    customerData: {
      name: 'PRONANS',
      offerTableName: 'Pronans'
    },
    propertiesKey: 'PRONANS',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: true,
    shareDataFeatureKey: 'SHARE_DATA_NORD',
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: false,
      sendProcessOfferEmail: false,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      addCustomerNumber: true,
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      logo: 'assets/images/customer_logo/logo-KLP.png',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://tilbud.pronans.no/',
      dev: 'https://pronans-front-end-dev.herokuapp.com/'
    }
  },
  AMESTO: {
    customerData: {
      name: 'AMEST0',
      offerTableName: 'AMESTO'
    },
    propertiesKey: 'AMEST0',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: true,
    shareDataFeatureKey: 'SHARE_DATA_NORD',
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: false,
      sendProcessOfferEmail: false,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      addCustomerNumber: true,
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      logo: 'assets/images/customer_logo/logo-KLP.png',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://tilbud.amesto.no/',
      dev: 'https://amesto-front-end-dev.herokuapp.com/'
    }
  },
  MMB: {
    customerData: {
      name: 'MECA/Bilxtra/Mekonomen',
      offerTableName: 'CODAN'
    },
    propertiesKey: 'MMB',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: true,
    shareDataFeatureKey: 'SHARE_DATA_NORD',
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: false,
      sendProcessOfferEmail: false,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      addCustomerNumber: true,
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      logo: 'assets/images/customer_logo/logo-KLP.png',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://ansatt.verksted.pronans.no/',
      dev: 'https://mmb-front-end-dev.herokuapp.com/'
    }
  },
  NORD: {
    customerData: {
      name: 'NORD',
      offerTableName: 'Nord'
    },
    propertiesKey: 'NORD',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: true,
    shareDataFeatureKey: 'SHARE_DATA_NORD',
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: true,
      sendProcessOfferEmail: false,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'tiaCustomerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      logo: 'assets/images/customer_logo/logo-KLP.png',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://nord-front-end-prod.herokuapp.com/', // TODO: Update when nord will setup base url
      dev: 'https://nord-front-end-dev.herokuapp.com/'
    }
  },
  IF: {
    customerData: {
      name: 'IF',
      offerTableName: 'If'
    },
    propertiesKey: 'IF',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: true,
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: true,
      sendProcessOfferEmail: false,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: false,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'tiaCustomerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://www.if.no/apps/guide/', // TODO: Update when if will setup base url
      dev: 'https://if-front-end-dev.herokuapp.com/'
    }
  },
  SCOOPR: {
    customerData: {
      name: 'SCOOPR',
      offerTableName: 'Scoopr'
    },
    propertiesKey: 'SCOOPR',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: true,
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: false,
      sendProcessOfferEmail: false,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'tiaCustomerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://intellitech.scoopr.no/',
      dev: 'https://dev.intellitech.scoopr.no/'
    }
  },
  RENTERADAR: {
    isWtcFlow: true,
    customerData: {
      name: 'RENTERADAR',
      offerTableName: 'Renteradar',
    },
    propertiesKey: 'WATERCIRCLES',
    isDefaultProperties: true,
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-+WtC.pdf',
    isStorebrand: true,
    isContemiIntegration: false,
    hasClaimsIn3YearsDrpdown: true,
    showAgentOrganisationId: true,
    isKNIF: true,
    isCreditCheckDisabled: true,
    isCustomerApprovedElectronicCommunicationFeature: false,
    isBoatTypes: true,
    offerTableView: 'WTC',
    actions: {
      assigneeOffer: true,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'customerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: true,
      isMultiplePaymentPeriods: true,
      downloadPdfButton: true
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://peilforsikring.no',
      dev: 'https://dev.peilforsikring.no'
    }
  },
  FORSIKRA: {
    isWtcFlow: true,
    customerData: {
      name: 'FORSIKRA',
      offerTableName: 'Forsikra',
    },
    propertiesKey: 'WATERCIRCLES',
    isDefaultProperties: true,
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-+WtC.pdf',
    isStorebrand: true,
    isContemiIntegration: false,
    hasClaimsIn3YearsDrpdown: true,
    showAgentOrganisationId: true,
    isKNIF: true,
    isCreditCheckDisabled: true,
    isCustomerApprovedElectronicCommunicationFeature: false,
    isBoatTypes: true,
    offerTableView: 'WTC',
    actions: {
      assigneeOffer: true,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'customerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: true,
      isMultiplePaymentPeriods: true,
      downloadPdfButton: true
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://forsikra-front-end-0f95e663f9c2.herokuapp.com',
      dev: 'https://forsikra-front-end-0f95e663f9c2.herokuapp.com'
    }
  },
  VERN: {
    isWtcFlow: true,
    customerData: {
      name: 'VERN',
      offerTableName: 'Vern',
    },
    propertiesKey: 'WATERCIRCLES',
    isDefaultProperties: true,
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-+WtC.pdf',
    isStorebrand: true,
    isContemiIntegration: false,
    hasClaimsIn3YearsDrpdown: true,
    showAgentOrganisationId: true,
    isKNIF: true,
    isCreditCheckDisabled: true,
    isCustomerApprovedElectronicCommunicationFeature: false,
    isBoatTypes: true,
    offerTableView: 'WTC',
    actions: {
      assigneeOffer: true,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'customerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: true,
      isMultiplePaymentPeriods: true,
      downloadPdfButton: true
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://vern-front-end-dev-9647e8e186e8.herokuapp.com',
      dev: 'https://vern-front-end-dev-9647e8e186e8.herokuapp.com'
    }
  },
  WATERCIRCLES: {
    isWtcFlow: true,
    showInvitations: true,
    customerData: {
      name: 'WATERCIRCLES',
      offerTableName: 'Watercircles',
      logo: 'logo-WTC.png'
    },
    isWtcDashboardDescription: true,
    propertiesKey: 'WATERCIRCLES',
    isDefaultProperties: true,
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-+WtC.pdf',
    isStorebrand: true,
    isContemiIntegration: true,
    hasClaimsIn3YearsDrpdown: true,
    showAgentOrganisationId: true,
    isKNIF: true,
    isCreditCheckDisabled: true,
    isCustomerApprovedElectronicCommunicationFeature: true,
    isBoatTypes: true,
    offerTableView: 'WTC',
    actions: {
      assigneeOffer: true,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'customerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: true,
      isMultiplePaymentPeriods: true,
      downloadPdfButton: true
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://tilbud.watercircles.no/',
      dev: 'https://watercircles-front-end-dev.herokuapp.com/'
    }
  },
  WINTERBERGH: {
    isWtcFlow: true,
    showInvitations: true,
    isWtcDashboardDescription: true,
    customerData: {
      name: 'WINTERBERGH',
      offerTableName: 'Winterbergh'
    },
    propertiesKey: 'WINTERBERGH',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: false,
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: false,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'customerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://tilbud.winterbergh.no/',
      dev: 'https://winterbergh-front-end-dev.herokuapp.com/'
    }
  },
  TOTEN: {
    customerData: {
      name: 'TOTEN',
      offerTableName: 'Toten'
    },
    propertiesKey: 'TOTEN',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: true,
    showAgentOrganisationId: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: true,
      sendProcessOfferEmail: false,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: false,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'tiaCustomerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://tilbud.totenforsikring.no/',
      dev: 'https://toten-front-end-dev.herokuapp.com/'
    }
  },
  TTFINANS: {
    customerData: {
      name: 'TT Finans',
      offerTableName: 'TT Finans'
    },
    isTTFlow: true,
    isSseOfferPriceClaculation: true,
    hasClaimsIn3YearsKolibriDrpdown: true,
    yearsInPreviousCompanyKolibriDrpdown: true,
    isPreviousCompanyFeature: true,
    isRegularPEPProperty: true,
    isDefaultProperties: true,
    propertiesKey: 'TTFINANS',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: true,
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false,
      isMultiplePaymentPeriods: false,
      downloadPdfButton: true
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://tilbud.ttforsikring.no/',
      dev: 'https://tt-front-end-dev.herokuapp.com/'
    }
  },
  STORM: {
    customerData: {
      name: 'STORM',
      offerTableName: 'Storm'
    },
    isStormFlow: true,
    isSseOfferPriceClaculation: true,
    hasClaimsIn3YearsKolibriDrpdown: true,
    yearsInPreviousCompanyKolibriDrpdown: true,
    isPreviousCompanyFeature: true,
    isRegularPEPProperty: true,
    isDefaultProperties: true,
    propertiesKey: 'STORM',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: true,
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false,
      isMultiplePaymentPeriods: false,
      downloadPdfButton: true
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://storm-front-end-dev-2331113e90c0.herokuapp.com/',
      dev: 'https://storm-front-end-dev-2331113e90c0.herokuapp.com/'
    }
  },
  BROKR: {
    customerData: {
      name: 'BROKR',
      offerTableName: 'Brokr'
    },
    propertiesKey: 'BROKR',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: false,
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: false,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: true,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'tiaCustomerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://tilbud.brokr.no/',
      dev: 'https://brokr-front-end-dev.herokuapp.com/'
    }
  },
  BROKR_TRYG: {
    customerData: {
      name: 'Brokr Tryg',
      offerTableName: 'Brokr Tryg'
    },
    propertiesKey: 'BROKR',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: false,
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: false,
      sendProcessOfferEmail: false,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: false,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'tiaCustomerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://brokr-tryg-front-end-prod.herokuapp.com/',
      dev: 'https://brokr-tryg-front-end-dev.herokuapp.com/'
    }
  },
  BROKR_LANDKREDITT: {
    customerData: {
      name: 'Brokr Landkreditt',
      offerTableName: 'Brokr Landkreditt'
    },
    propertiesKey: 'BROKR',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: false,
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: false,
      sendProcessOfferEmail: false,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: false,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'tiaCustomerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://brokr-landkredit-front-end-prod.herokuapp.com/',
      dev: 'https://brokr-landkredit-front-end-dev.herokuapp.com/'
    }
  },
  EIKA: {
    customerData: {
      name: 'EIKA',
      offerTableName: 'Eika'
    },
    propertiesKey: 'EIKA',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech-brukermanual-Eika.pdf',
    isStorebrand: true,
    isEika: true,
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: false,
      sendProcessOfferEmail: false,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: false,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'tiaCustomerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://forsikringstilbud.eika.no/',
      dev: 'https://eika-front-end-dev.herokuapp.com/'
    }
  },
  INSAVER: {
    customerData: {
      name: 'INSAVER',
      offerTableName: 'Insaver'
    },
    propertiesKey: 'INSAVER',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: true,
    isEika: false,
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: false,
      sendProcessOfferEmail: false,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: false,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'tiaCustomerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: true,
      sendOfferInit: true,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://insaver-front-end-prod.herokuapp.com/',
      dev: 'https://insaver-front-end-dev.herokuapp.com/'
    }
  },
  CODAN: {
    customerData: {
      name: 'CODAN',
      offerTableName: 'Codan'
    },
    propertiesKey: 'CODAN',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: false,
    isEika: false,
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: true,
      sendProcessEmail: false,
      sendProcessOfferEmail: false,
      sendProcessOfferSMS: true,
      sendOfferEmail: false,
      sendOfferEditReminder: false,
      offerProductActions: true,
      editOfferStatus: true,
      sendOfferComments: true,
      customerNumberObject: 'tiaCustomerNumber',
      viewOfferStatusLogic: true,
      viewProductProperties: true,
      showOfferLink: false,
      sendOfferInit: false,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'assignType',
          value: 'ME'
        },
        {
          controlName: 'needAssistanceOffers',
          value: true
        },
        {
          controlName: 'pendingOffers',
          value: true
        },
        {
          controlName: 'failedOffers',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://upload.privatsikring.dk/',
      dev: 'https://upload-dev.privatsikring.dk/'
    }
  },
  SAS: {
    customerData: {
      name: 'Sas',
      offerTableName: 'Sas'
    },
    propertiesKey: 'SAS',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: false,
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: false,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: true,
      sendOfferEditReminder: false,
      offerProductActions: false,
      editOfferStatus: false,
      sendOfferComments: false,
      viewOfferStatusLogic: false,
      viewProductProperties: false,
      showOfferLink: false,
      sendOfferInit: false,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      logo: 'assets/images/customer_logo/logo-TIDE.png',
      picture: 'assets/images/admin.jpg',
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'inbox',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://tilbud.tideforsikring.no/',
      dev: 'https://tide-frontend-dev.herokuapp.com/'
    }
  },
  TIDE: {
    customerData: {
      name: 'Tide',
      offerTableName: 'Tide'
    },
    propertiesKey: 'TIDE',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: false,
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: false,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: true,
      sendOfferEditReminder: false,
      offerProductActions: false,
      editOfferStatus: false,
      sendOfferComments: false,
      viewOfferStatusLogic: false,
      viewProductProperties: false,
      showOfferLink: false,
      sendOfferInit: false,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      logo: 'assets/images/customer_logo/logo-TIDE.png',
      picture: 'assets/images/admin.jpg'
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'inbox',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://tilbud.tideforsikring.no/',
      dev: 'https://tide-frontend-dev.herokuapp.com/'
    }
  },
  KLUBBDEAL: {
    customerData: {
      name: 'Klubb deal',
      offerTableName: 'Klubb deal'
    },
    propertiesKey: 'KLUBB_DEAL',
    customerNumberKey: 'CUSTOMER_NUMBER',
    customerNumberLabel: 'CUSTOMER_NUMBER_LABEL',
    propertyValuesMapListName: 'PROPERTIES_VALUES',
    userManualLink: 'https://intellitech-public.s3.eu-north-1.amazonaws.com/Intellitech+brukermanual+-++IntelliSale.pdf',
    isStorebrand: false,
    showAgentOrganisationId: true,
    isKNIF: true,
    actions: {
      assigneeOffer: false,
      sendProcessEmail: true,
      sendProcessOfferEmail: true,
      sendProcessOfferSMS: true,
      sendOfferEmail: true,
      sendOfferEditReminder: false,
      offerProductActions: false,
      editOfferStatus: false,
      sendOfferComments: false,
      viewOfferStatusLogic: false,
      viewProductProperties: false,
      showOfferLink: false,
      sendOfferInit: false,
      isTarifDate: false
    },
    profileData: {
      name: 'Admin',
      logo: 'assets/images/customer_logo/logo-KLUBB_DEAL.png',
      picture: 'assets/images/admin.jpg'
    },
    filter: {
      type: 'basicFilter',
      predefinedFilters: [
        {
          controlName: 'inbox',
          value: true
        }
      ]
    },
    userUiUrl: {
      prod: 'https://tilbud.tideforsikring.no/',
      dev: 'https://tide-frontend-dev.herokuapp.com/'
    }
  },
};
